import { createBrowserRouter } from "react-router";
import { ConsoleShell } from "./components/ConsoleShell";
import { Brands } from "./pages/Brands";
import { Callback } from "./pages/Callback";
import { Home } from "./pages/Home";
import { Invitation } from "./pages/Invitation";
import { Organization } from "./pages/Organization";
import { SignIn } from "./pages/SignIn";
import { Apps } from "./pages/Apps";
import { AppDetail } from "./pages/AppDetail";
import { Approvals } from "./pages/Approvals";
import { ProposalDetail } from "./pages/ProposalDetail";

export const router = createBrowserRouter([
  {
    element: <ConsoleShell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/orgs/:id", element: <Organization /> },
      { path: "/orgs/:id/apps", element: <Apps /> },
      { path: "/orgs/:id/apps/:clientId", element: <AppDetail /> },
      { path: "/roles", lazy: async () => ({ Component: (await import("./pages/Roles")).Roles }) },
      { path: "/orgs/:id/roles", lazy: async () => ({ Component: (await import("./pages/Roles")).Roles }) },
      { path: "/orgs/:id/roles/:roleKey", lazy: async () => ({ Component: (await import("./pages/RoleDetail")).RoleDetail }) },
      {
        path: "/agents",
        lazy: async () => ({
          Component: (await import("./pages/Agents")).Agents,
        }),
      },
      {
        path: "/orgs/:id/agents",
        lazy: async () => ({
          Component: (await import("./pages/Agents")).Agents,
        }),
      },
      {
        path: "/orgs/:id/agents/:agentId",
        lazy: async () => ({
          Component: (await import("./pages/AgentDetail")).AgentDetail,
        }),
      },
      { path: "/approvals", element: <Approvals /> },
      { path: "/approvals/:org/:proposalId", element: <ProposalDetail /> },
      { path: "/orgs/:id/brands", element: <Brands /> },
      {
        path: "/orgs/:id/brands/:brandId",
        lazy: async () => ({
          Component: (await import("./pages/BrandEditor")).BrandEditor,
        }),
      },
      { path: "/invitations", element: <Invitation /> },
      { path: "/signin", element: <SignIn /> },
      { path: "/callback", element: <Callback /> },
    ],
  },
]);
